import { render, staticRenderFns } from "./TheLoading.vue?vue&type=template&id=26b929a8&"
import script from "./TheLoading.vue?vue&type=script&lang=ts&"
export * from "./TheLoading.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports